const IconSocialMedia = ({ imagen, title, url}) => (
	<a href={url} target="_blank" rel="noreferrer">
		<div className="icon-media--width">
			<img src={imagen} alt={title} />
		</div>	
	</a>
)

export default IconSocialMedia